/**
 * Jainsons Lights - Photo Search Storefront Widget
 * 
 * DEPLOYMENT INSTRUCTIONS:
 * Include this asset via a defer script tag before the closing </body> tag in theme.liquid:
 * <script src="{{ 'jl-photo-search.js' | asset_url }}" defer="defer"></script>
 */

(function () {
  'use strict';

  // Guard against double initialization
  if (window.JLPhotoSearchInitialized) return;
  window.JLPhotoSearchInitialized = true;

  // CSS Styles Injection
  function injectStyles() {
    if (document.getElementById('jlps-styles')) return;
    const style = document.createElement('style');
    style.id = 'jlps-styles';
    style.textContent = `
      @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Manrope:wght@300;400;500;600;700;800&display=swap');

      .jlps-camera-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 1.5rem;
        background: transparent;
        border: none;
        cursor: pointer;
        font-size: 1.8rem;
        line-height: 1;
        padding: 0.5rem;
        margin: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        z-index: 5;
        color: #8a5a2c;
        transition: transform 0.2s ease, opacity 0.2s ease;
      }
      .jlps-camera-btn:hover {
        transform: translateY(-50%) scale(1.2);
      }
      .jlps-camera-btn--with-button {
        right: 5.5rem;
      }

      .jlps-modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(58, 42, 24, 0.65);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 2147483647;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        padding: 16px;
        box-sizing: border-box;
      }
      .jlps-modal-overlay.jlps-active {
        opacity: 1;
        pointer-events: auto;
      }

      .jlps-modal-card {
        background-color: #fbf7f0;
        color: #2a2118;
        width: 100%;
        max-width: 500px;
        border-radius: 18px;
        box-shadow: 0 20px 48px rgba(58, 42, 24, 0.15), 0 4px 16px rgba(58, 42, 24, 0.08);
        position: relative;
        padding: 32px 24px 24px 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        font-family: 'Manrope', system-ui, -apple-system, BlinkMacSystemFont, Arial, sans-serif;
        max-height: 90vh;
        overflow-y: auto;
        box-sizing: border-box;
        transform: scale(0.95);
        transition: transform 0.3s ease;
      }
      .jlps-modal-overlay.jlps-active .jlps-modal-card {
        transform: scale(1);
      }

      .jlps-close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        background: none;
        border: none;
        font-size: 24px;
        cursor: pointer;
        color: #3a2a18;
        padding: 4px;
        line-height: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: color 0.2s ease, transform 0.2s ease;
      }
      .jlps-close-btn:hover {
        color: #8a5a2c;
        transform: scale(1.15);
      }

      .jlps-title {
        font-family: 'Cormorant Garamond', Georgia, serif;
        font-size: 28px;
        font-weight: 600;
        color: #3a2a18;
        margin: 0;
        text-align: center;
      }
      .jlps-subtitle {
        font-family: 'Manrope', system-ui, Arial, sans-serif;
        font-size: 14px;
        color: #7a6f5f;
        margin: -8px 0 8px 0;
        text-align: center;
        line-height: 1.4;
      }

      .jlps-actions-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .jlps-btn-group {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .jlps-btn {
        background-color: #8a5a2c;
        color: #fbf7f0;
        border: 1px solid #8a5a2c;
        padding: 14px 24px;
        border-radius: 12px;
        font-family: 'Manrope', system-ui, Arial, sans-serif;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s, border-color 0.2s, transform 0.1s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        box-shadow: 0 4px 12px rgba(138, 90, 44, 0.15);
      }
      .jlps-btn:hover {
        background-color: #724922;
        border-color: #724922;
      }
      .jlps-btn:active {
        transform: scale(0.98);
      }

      .jlps-btn-secondary {
        background-color: transparent;
        color: #8a5a2c;
        border: 1px solid #8a5a2c;
        padding: 12px 24px;
        border-radius: 12px;
        font-family: 'Manrope', system-ui, Arial, sans-serif;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s, color 0.2s, transform 0.1s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
      }
      .jlps-btn-secondary:hover {
        background-color: #f5ecda;
      }
      .jlps-btn-secondary:active {
        transform: scale(0.98);
      }

      .jlps-wa-btn {
        background-color: #25D366;
        color: #ffffff;
        border: 1px solid #25D366;
        padding: 14px 24px;
        border-radius: 12px;
        font-family: 'Manrope', system-ui, Arial, sans-serif;
        font-size: 15px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s, border-color 0.2s, transform 0.1s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        box-shadow: 0 4px 12px rgba(37, 211, 102, 0.15);
        text-decoration: none;
      }
      .jlps-wa-btn:hover {
        background-color: #20ba5a;
        border-color: #20ba5a;
      }
      .jlps-wa-btn:active {
        transform: scale(0.98);
      }

      .jlps-preview-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin: 16px 0;
      }
      .jlps-preview-thumbnail {
        width: 120px;
        height: 120px;
        object-fit: cover;
        border-radius: 14px;
        border: 2px solid #8a5a2c;
        box-shadow: 0 6px 16px rgba(58, 42, 24, 0.1);
      }
      .jlps-modal-card--crop {
        max-width: 680px;
      }
      .jlps-crop-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin: 8px 0;
      }
      .jlps-crop-frame {
        position: relative;
        width: fit-content;
        max-width: 100%;
        line-height: 0;
        touch-action: none;
      }
      .jlps-crop-image {
        display: block;
        max-width: 100%;
        max-height: 50vh;
        object-fit: contain;
        border-radius: 16px;
        border: 1px solid #efe7d6;
        box-shadow: 0 10px 28px rgba(58, 42, 24, 0.12);
        user-select: none;
        -webkit-user-drag: none;
      }
      .jlps-crop-box {
        position: absolute;
        border: 2px solid #fbf7f0;
        box-shadow: 0 0 0 9999px rgba(58, 42, 24, 0.42), inset 0 0 0 1px rgba(138, 90, 44, 0.85);
        cursor: move;
        touch-action: none;
        box-sizing: border-box;
      }
      .jlps-crop-box::before,
      .jlps-crop-box::after {
        content: "";
        position: absolute;
        pointer-events: none;
      }
      .jlps-crop-box::before {
        left: 33.333%;
        right: 33.333%;
        top: 0;
        bottom: 0;
        border-left: 1px solid rgba(251, 247, 240, 0.55);
        border-right: 1px solid rgba(251, 247, 240, 0.55);
      }
      .jlps-crop-box::after {
        top: 33.333%;
        bottom: 33.333%;
        left: 0;
        right: 0;
        border-top: 1px solid rgba(251, 247, 240, 0.55);
        border-bottom: 1px solid rgba(251, 247, 240, 0.55);
      }
      .jlps-crop-handle {
        position: absolute;
        width: 32px;
        height: 32px;
        background-color: #fbf7f0;
        border: 2px solid #8a5a2c;
        border-radius: 999px;
        box-shadow: 0 4px 10px rgba(58, 42, 24, 0.18);
        box-sizing: border-box;
        touch-action: none;
        z-index: 2;
      }
      .jlps-crop-handle-nw {
        top: -16px;
        left: -16px;
        cursor: nwse-resize;
      }
      .jlps-crop-handle-ne {
        top: -16px;
        right: -16px;
        cursor: nesw-resize;
      }
      .jlps-crop-handle-sw {
        bottom: -16px;
        left: -16px;
        cursor: nesw-resize;
      }
      .jlps-crop-handle-se {
        bottom: -16px;
        right: -16px;
        cursor: nwse-resize;
      }
      .jlps-crop-actions {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        gap: 12px;
        width: 100%;
      }
      .jlps-crop-actions .jlps-btn,
      .jlps-crop-actions .jlps-btn-secondary {
        min-width: 190px;
      }
      .jlps-btn:disabled,
      .jlps-btn-secondary:disabled {
        opacity: 0.65;
        cursor: not-allowed;
      }
      .jlps-status-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
      }
      .jlps-status-text {
        font-family: 'Manrope', system-ui, Arial, sans-serif;
        font-size: 15px;
        font-weight: 500;
        color: #8a5a2c;
      }
      .jlps-spinner {
        width: 20px;
        height: 20px;
        border: 2.5px solid rgba(138, 90, 44, 0.2);
        border-top-color: #8a5a2c;
        border-radius: 50%;
        animation: jlps-spin 0.8s linear infinite;
      }

      .jlps-results-container {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .jlps-results-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        max-height: 50vh;
        overflow-y: auto;
        padding-right: 4px;
      }
      @media (max-width: 480px) {
        .jlps-results-grid {
          grid-template-columns: 1fr;
        }
      }

      .jlps-modal-card::-webkit-scrollbar,
      .jlps-results-grid::-webkit-scrollbar {
        width: 6px;
      }
      .jlps-modal-card::-webkit-scrollbar-track,
      .jlps-results-grid::-webkit-scrollbar-track {
        background: transparent;
      }
      .jlps-modal-card::-webkit-scrollbar-thumb,
      .jlps-results-grid::-webkit-scrollbar-thumb {
        background: #efe7d6;
        border-radius: 3px;
      }
      .jlps-modal-card::-webkit-scrollbar-thumb:hover,
      .jlps-results-grid::-webkit-scrollbar-thumb:hover {
        background: #7a6f5f;
      }

      .jlps-match-card {
        display: flex;
        flex-direction: column;
        background-color: #ffffff;
        border: 1px solid #efe7d6;
        border-radius: 14px;
        text-decoration: none;
        color: #2a2118;
        overflow: hidden;
        transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
        box-shadow: 0 4px 10px rgba(58, 42, 24, 0.03);
      }
      .jlps-match-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 10px 20px rgba(58, 42, 24, 0.08);
        border-color: #8a5a2c;
      }
      .jlps-match-thumb-container {
        position: relative;
        width: 100%;
        padding-bottom: 100%;
        background-color: #ffffff;
      }
      .jlps-match-thumb {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: contain;
        padding: 8px;
        box-sizing: border-box;
      }
      .jlps-match-info {
        padding: 12px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        flex-grow: 1;
        border-top: 1px solid #efe7d6;
      }
      .jlps-match-title {
        font-size: 13px;
        font-weight: 600;
        line-height: 1.4;
        margin: 0;
        color: #3a2a18;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 2.8em;
      }
      .jlps-match-meta {
        font-size: 12px;
        color: #7a6f5f;
        margin: 0;
      }
      .jlps-match-badge-row {
        display: flex;
        justify-content: flex-start;
        margin-top: auto;
      }

      .jlps-badge {
        display: inline-block;
        padding: 3px 8px;
        border-radius: 999px;
        font-size: 10px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        line-height: 1;
      }
      .jlps-badge-exact {
        background-color: #3a2a18;
        color: #fbf7f0;
      }
      .jlps-badge-close {
        background-color: #8a5a2c;
        color: #fbf7f0;
      }
      .jlps-badge-similar {
        background-color: #efe7d6;
        color: #7a6f5f;
      }

      .jlps-message-area {
        text-align: center;
        padding: 16px 0;
      }
      .jlps-empty-message, .jlps-error-message {
        font-size: 14px;
        line-height: 1.6;
        color: #7a6f5f;
        margin: 0;
      }

      @keyframes jlps-spin {
        to { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  // HTML Modal structure variables
  let modalOverlay = null;
  let card = null;
  let cropState = null;
  const MIN_CROP_SIZE = 48;

  function injectModal() {
    if (document.querySelector('.jlps-modal-overlay')) return;

    modalOverlay = document.createElement('div');
    modalOverlay.className = 'jlps-modal-overlay';
    modalOverlay.innerHTML = `
      <div class="jlps-modal-card">
        <button type="button" class="jlps-close-btn" aria-label="Close modal">&times;</button>
        <h2 class="jlps-title">Search by photo</h2>
        <p class="jlps-subtitle">Find Jainsons Lights by uploading an image</p>

        <div class="jlps-content-area">
          <!-- Action buttons (Take / Upload) -->
          <div class="jlps-actions-container">
            <div class="jlps-btn-group">
              <button type="button" class="jlps-btn jlps-btn-take">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                Take a photo
              </button>
              <button type="button" class="jlps-btn jlps-btn-upload">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                Upload a photo
              </button>
            </div>
            <input type="file" class="jlps-file-take" accept="image/*" capture="environment" style="display: none;">
            <input type="file" class="jlps-file-upload" accept="image/*" style="display: none;">
          </div>

          <!-- Crop state -->
          <div class="jlps-crop-container" style="display: none;">
            <div class="jlps-crop-frame">
              <img class="jlps-crop-image" src="" alt="Selected photo">
              <div class="jlps-crop-box" role="presentation">
                <span class="jlps-crop-handle jlps-crop-handle-nw" data-corner="nw"></span>
                <span class="jlps-crop-handle jlps-crop-handle-ne" data-corner="ne"></span>
                <span class="jlps-crop-handle jlps-crop-handle-sw" data-corner="sw"></span>
                <span class="jlps-crop-handle jlps-crop-handle-se" data-corner="se"></span>
              </div>
            </div>
            <div class="jlps-crop-actions">
              <button type="button" class="jlps-btn jlps-btn-crop-search">Search this area</button>
              <button type="button" class="jlps-btn-secondary jlps-btn-whole-search">Search whole photo</button>
            </div>
          </div>

          <!-- Preview / Loading state -->
          <div class="jlps-preview-container" style="display: none;">
            <img class="jlps-preview-thumbnail" src="" alt="Preview">
            <div class="jlps-status-container">
              <div class="jlps-spinner"></div>
              <span class="jlps-status-text">Finding your light…</span>
            </div>
          </div>

          <!-- Results / Error / Empty state container -->
          <div class="jlps-results-container" style="display: none;">
            <div class="jlps-results-grid"></div>
            <div class="jlps-message-area"></div>
            <div class="jlps-footer-actions" style="margin-top: 16px; display: flex; flex-direction: column; gap: 8px;"></div>
          </div>
        </div>
      </div>
    `;

    document.body.appendChild(modalOverlay);
    card = modalOverlay.querySelector('.jlps-modal-card');

    setupModalEvents();
  }

  function setupModalEvents() {
    const closeBtn = card.querySelector('.jlps-close-btn');
    closeBtn.addEventListener('click', closeModal);

    modalOverlay.addEventListener('click', (e) => {
      if (e.target === modalOverlay) {
        closeModal();
      }
    });

    const btnTake = card.querySelector('.jlps-btn-take');
    const btnUpload = card.querySelector('.jlps-btn-upload');
    const takeInput = card.querySelector('.jlps-file-take');
    const uploadInput = card.querySelector('.jlps-file-upload');
    const cropBox = card.querySelector('.jlps-crop-box');
    const cropSearchBtn = card.querySelector('.jlps-btn-crop-search');
    const wholeSearchBtn = card.querySelector('.jlps-btn-whole-search');

    btnTake.addEventListener('click', () => takeInput.click());
    btnUpload.addEventListener('click', () => uploadInput.click());

    takeInput.addEventListener('change', handleFileSelect);
    uploadInput.addEventListener('change', handleFileSelect);

    cropBox.addEventListener('pointerdown', handleCropPointerDown);
    cropBox.addEventListener('pointermove', handleCropPointerMove);
    cropBox.addEventListener('pointerup', handleCropPointerUp);
    cropBox.addEventListener('pointercancel', handleCropPointerUp);

    cropSearchBtn.addEventListener('click', handleCropSearch);
    wholeSearchBtn.addEventListener('click', handleWholePhotoSearch);
    window.addEventListener('resize', handleCropResize);
  }

  function openModal() {
    resetModalState();
    if (modalOverlay) {
      modalOverlay.classList.add('jlps-active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    if (modalOverlay) {
      modalOverlay.classList.remove('jlps-active');
      document.body.style.overflow = '';
    }
    cleanupCropState();
  }

  function showState(state) {
    const actionsContainer = card.querySelector('.jlps-actions-container');
    const cropContainer = card.querySelector('.jlps-crop-container');
    const previewContainer = card.querySelector('.jlps-preview-container');
    const resultsContainer = card.querySelector('.jlps-results-container');
    card.classList.toggle('jlps-modal-card--crop', state === 'crop');

    if (state === 'initial') {
      actionsContainer.style.display = 'flex';
      cropContainer.style.display = 'none';
      previewContainer.style.display = 'none';
      resultsContainer.style.display = 'none';
    } else if (state === 'crop') {
      actionsContainer.style.display = 'none';
      cropContainer.style.display = 'flex';
      previewContainer.style.display = 'none';
      resultsContainer.style.display = 'none';
    } else if (state === 'loading') {
      actionsContainer.style.display = 'none';
      cropContainer.style.display = 'none';
      previewContainer.style.display = 'flex';
      resultsContainer.style.display = 'none';
    } else if (state === 'results') {
      actionsContainer.style.display = 'none';
      cropContainer.style.display = 'none';
      previewContainer.style.display = 'none';
      resultsContainer.style.display = 'flex';
    }
  }

  function resetModalState() {
    cleanupCropState();

    const takeInput = card.querySelector('.jlps-file-take');
    const uploadInput = card.querySelector('.jlps-file-upload');
    if (takeInput) takeInput.value = '';
    if (uploadInput) uploadInput.value = '';

    const previewImg = card.querySelector('.jlps-preview-thumbnail');
    if (previewImg) previewImg.src = '';
    const cropImg = card.querySelector('.jlps-crop-image');
    if (cropImg) cropImg.src = '';

    const grid = card.querySelector('.jlps-results-grid');
    const msgArea = card.querySelector('.jlps-message-area');
    const footerActions = card.querySelector('.jlps-footer-actions');
    if (grid) grid.innerHTML = '';
    if (msgArea) msgArea.innerHTML = '';
    if (footerActions) footerActions.innerHTML = '';

    showState('initial');
  }

  function handleFileSelect(e) {
    const file = e.target.files[0];
    if (!file) return;

    // Clear file inputs so same file can be selected again later
    const takeInput = card.querySelector('.jlps-file-take');
    const uploadInput = card.querySelector('.jlps-file-upload');
    takeInput.value = '';
    uploadInput.value = '';

    showCropStep(file);
  }

  function cleanupCropState() {
    if (cropState && cropState.objectUrl) {
      URL.revokeObjectURL(cropState.objectUrl);
    }
    cropState = null;
    setCropButtonsDisabled(false);
  }

  function showCropStep(file) {
    cleanupCropState();

    const cropImg = card.querySelector('.jlps-crop-image');
    const cropBox = card.querySelector('.jlps-crop-box');
    const objectUrl = URL.createObjectURL(file);

    cropState = {
      file: file,
      objectUrl: objectUrl,
      rect: null,
      displayWidth: 0,
      displayHeight: 0,
      activePointerId: null,
      mode: null,
      startX: 0,
      startY: 0,
      startRect: null
    };

    cropBox.style.display = 'none';
    cropImg.onload = function() {
      showState('crop');
      requestAnimationFrame(() => {
        setDefaultCropRect();
        if (cropState && cropState.rect) {
          cropBox.style.display = 'block';
        }
      });
    };
    cropImg.onerror = function() {
      renderError();
    };
    cropImg.src = objectUrl;
  }

  function getCropBounds() {
    const cropImg = card.querySelector('.jlps-crop-image');
    return {
      width: cropImg.clientWidth,
      height: cropImg.clientHeight
    };
  }

  function setDefaultCropRect() {
    if (!cropState) return;

    const bounds = getCropBounds();
    if (!bounds.width || !bounds.height) return;

    cropState.displayWidth = bounds.width;
    cropState.displayHeight = bounds.height;
    cropState.rect = clampCropRect({
      x: bounds.width * 0.15,
      y: bounds.height * 0.15,
      width: bounds.width * 0.7,
      height: bounds.height * 0.7
    }, bounds);

    updateCropBox();
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function clampCropRect(rect, bounds) {
    const minWidth = Math.min(MIN_CROP_SIZE, bounds.width);
    const minHeight = Math.min(MIN_CROP_SIZE, bounds.height);
    const width = clamp(rect.width, minWidth, bounds.width);
    const height = clamp(rect.height, minHeight, bounds.height);
    const x = clamp(rect.x, 0, Math.max(0, bounds.width - width));
    const y = clamp(rect.y, 0, Math.max(0, bounds.height - height));

    return { x: x, y: y, width: width, height: height };
  }

  function updateCropBox() {
    if (!cropState || !cropState.rect) return;

    const cropBox = card.querySelector('.jlps-crop-box');
    cropBox.style.left = cropState.rect.x + 'px';
    cropBox.style.top = cropState.rect.y + 'px';
    cropBox.style.width = cropState.rect.width + 'px';
    cropBox.style.height = cropState.rect.height + 'px';
  }

  function resizeCropRect(corner, dx, dy, bounds) {
    const start = cropState.startRect;
    let left = start.x;
    let top = start.y;
    let right = start.x + start.width;
    let bottom = start.y + start.height;

    if (corner.indexOf('w') !== -1) {
      left = clamp(left + dx, 0, right - Math.min(MIN_CROP_SIZE, bounds.width));
    }
    if (corner.indexOf('e') !== -1) {
      right = clamp(right + dx, left + Math.min(MIN_CROP_SIZE, bounds.width), bounds.width);
    }
    if (corner.indexOf('n') !== -1) {
      top = clamp(top + dy, 0, bottom - Math.min(MIN_CROP_SIZE, bounds.height));
    }
    if (corner.indexOf('s') !== -1) {
      bottom = clamp(bottom + dy, top + Math.min(MIN_CROP_SIZE, bounds.height), bounds.height);
    }

    return {
      x: left,
      y: top,
      width: right - left,
      height: bottom - top
    };
  }

  function handleCropPointerDown(e) {
    if (!cropState || !cropState.rect) return;

    e.preventDefault();
    const cropBox = card.querySelector('.jlps-crop-box');
    cropBox.setPointerCapture(e.pointerId);

    cropState.activePointerId = e.pointerId;
    cropState.mode = e.target.getAttribute('data-corner') || 'move';
    cropState.startX = e.clientX;
    cropState.startY = e.clientY;
    cropState.startRect = {
      x: cropState.rect.x,
      y: cropState.rect.y,
      width: cropState.rect.width,
      height: cropState.rect.height
    };
  }

  function handleCropPointerMove(e) {
    if (!cropState || cropState.activePointerId !== e.pointerId || !cropState.startRect) return;

    e.preventDefault();
    const bounds = getCropBounds();
    const dx = e.clientX - cropState.startX;
    const dy = e.clientY - cropState.startY;

    if (cropState.mode === 'move') {
      cropState.rect = clampCropRect({
        x: cropState.startRect.x + dx,
        y: cropState.startRect.y + dy,
        width: cropState.startRect.width,
        height: cropState.startRect.height
      }, bounds);
    } else {
      cropState.rect = clampCropRect(resizeCropRect(cropState.mode, dx, dy, bounds), bounds);
    }

    updateCropBox();
  }

  function handleCropPointerUp(e) {
    if (!cropState || cropState.activePointerId !== e.pointerId) return;

    const cropBox = card.querySelector('.jlps-crop-box');
    if (cropBox.hasPointerCapture(e.pointerId)) {
      cropBox.releasePointerCapture(e.pointerId);
    }

    cropState.activePointerId = null;
    cropState.mode = null;
    cropState.startRect = null;
  }

  function handleCropResize() {
    if (!cropState || !cropState.rect) return;

    const bounds = getCropBounds();
    if (!bounds.width || !bounds.height) return;

    const scaleX = cropState.displayWidth ? bounds.width / cropState.displayWidth : 1;
    const scaleY = cropState.displayHeight ? bounds.height / cropState.displayHeight : 1;
    cropState.rect = clampCropRect({
      x: cropState.rect.x * scaleX,
      y: cropState.rect.y * scaleY,
      width: cropState.rect.width * scaleX,
      height: cropState.rect.height * scaleY
    }, bounds);
    cropState.displayWidth = bounds.width;
    cropState.displayHeight = bounds.height;
    updateCropBox();
  }

  function setCropButtonsDisabled(disabled) {
    if (!card) return;
    const cropSearchBtn = card.querySelector('.jlps-btn-crop-search');
    const wholeSearchBtn = card.querySelector('.jlps-btn-whole-search');
    if (cropSearchBtn) cropSearchBtn.disabled = disabled;
    if (wholeSearchBtn) wholeSearchBtn.disabled = disabled;
  }

  function handleWholePhotoSearch() {
    if (!cropState || !cropState.file) return;
    searchWithFile(cropState.file, cropState.objectUrl);
  }

  function handleCropSearch() {
    if (!cropState || !cropState.rect) return;

    setCropButtonsDisabled(true);
    createCroppedBlob()
      .then(blob => {
        const previewSrc = URL.createObjectURL(blob);
        searchWithFile(blob, previewSrc, 'jainsons-photo-search-crop.jpg');
      })
      .catch(err => {
        console.error('[JLPhotoSearch] Error while cropping image:', err);
        renderError();
      });
  }

  function createCroppedBlob() {
    return new Promise((resolve, reject) => {
      if (!cropState || !cropState.rect) {
        reject(new Error('Crop area is not ready'));
        return;
      }

      const cropImg = card.querySelector('.jlps-crop-image');
      const displayWidth = cropImg.clientWidth;
      const displayHeight = cropImg.clientHeight;

      if (!displayWidth || !displayHeight || !cropImg.naturalWidth || !cropImg.naturalHeight) {
        reject(new Error('Image dimensions are not ready'));
        return;
      }

      const scaleX = cropImg.naturalWidth / displayWidth;
      const scaleY = cropImg.naturalHeight / displayHeight;
      const sx = Math.max(0, Math.round(cropState.rect.x * scaleX));
      const sy = Math.max(0, Math.round(cropState.rect.y * scaleY));
      const sw = Math.max(1, Math.min(cropImg.naturalWidth - sx, Math.round(cropState.rect.width * scaleX)));
      const sh = Math.max(1, Math.min(cropImg.naturalHeight - sy, Math.round(cropState.rect.height * scaleY)));
      const canvas = document.createElement('canvas');
      canvas.width = sw;
      canvas.height = sh;

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas context is not available'));
        return;
      }

      ctx.drawImage(cropImg, sx, sy, sw, sh, 0, 0, sw, sh);
      canvas.toBlob(blob => {
        if (blob) {
          resolve(blob);
        } else {
          reject(new Error('Could not create cropped image'));
        }
      }, 'image/jpeg', 0.9);
    });
  }

  function searchWithFile(fileOrBlob, previewSrc, filename) {
    const previewImg = card.querySelector('.jlps-preview-thumbnail');
    previewImg.src = previewSrc || '';
    showState('loading');

    const formData = new FormData();
    if (filename) {
      formData.append('file', fileOrBlob, filename);
    } else {
      formData.append('file', fileOrBlob);
    }

    fetch('https://aria.jainsonslights.com/vm/api/match?top_k=8', {
      method: 'POST',
      body: formData
    })
    .then(res => {
      if (!res.ok) throw new Error('API server returned status ' + res.status);
      return res.json();
    })
    .then(data => {
      if (data && Array.isArray(data.matches)) {
        renderResults(data.matches);
      } else {
        renderResults([]);
      }
    })
    .catch(err => {
      console.error('[JLPhotoSearch] Error during matching:', err);
      renderError();
    });
  }

  function escapeHtml(text) {
    if (text === null || text === undefined) return '';
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function getTruncatedEscapedTitle(title) {
    if (!title) return '';
    let truncated = title;
    if (title.length > 80) {
      truncated = title.substring(0, 77) + '...';
    }
    return escapeHtml(truncated);
  }

  function formatScore(score) {
    if (typeof score !== 'number') {
      const parsed = parseFloat(score);
      if (isNaN(parsed)) return '0';
      score = parsed;
    }
    if (score <= 1) {
      return Math.round(score * 100);
    }
    return Math.round(score);
  }

  function getConfidenceBadge(confidence) {
    const conf = String(confidence || '').toLowerCase().trim();
    if (conf === 'exact') {
      return `<span class="jlps-badge jlps-badge-exact">Exact</span>`;
    } else if (conf === 'similar') {
      return `<span class="jlps-badge jlps-badge-close">Close</span>`;
    } else {
      return `<span class="jlps-badge jlps-badge-similar">Similar</span>`;
    }
  }

  function renderResults(matches) {
    const grid = card.querySelector('.jlps-results-grid');
    const msgArea = card.querySelector('.jlps-message-area');
    const footerActions = card.querySelector('.jlps-footer-actions');

    grid.innerHTML = '';
    msgArea.innerHTML = '';
    footerActions.innerHTML = '';

    const waLink = `https://wa.me/919899188821?text=${encodeURIComponent('help me find this light')}`;

    if (matches.length === 0) {
      grid.style.display = 'none';
      msgArea.innerHTML = `
        <p class="jlps-empty-message">No matching lights found. Our design team can help you find or customize this light directly!</p>
      `;
      footerActions.innerHTML = `
        <a href="${waLink}" target="_blank" rel="noopener" class="jlps-wa-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 4px;"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.717-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.632-1.023-5.105-2.887-6.97C16.587 1.968 14.117.943 11.487.942c-5.442 0-9.866 4.42-9.87 9.852 0 1.764.464 3.486 1.343 5.006l-1.016 3.71 3.818-1.002zM17.65 14.4c-.31-.155-1.833-.903-2.115-1.005-.281-.102-.486-.153-.69.155-.205.307-.792 1.005-.97 1.21-.179.205-.357.23-.667.076-.31-.155-1.308-.482-2.492-1.538-.92-.82-1.54-1.833-1.72-2.14-.18-.307-.02-.473.136-.628.14-.138.31-.357.466-.537.155-.179.207-.307.31-.512.102-.205.05-.383-.025-.537-.075-.154-.69-1.662-.945-2.277-.25-.598-.5-.517-.69-.527-.179-.008-.383-.01-.588-.01-.205 0-.537.076-.819.383-.282.307-1.074 1.05-1.074 2.56 0 1.51 1.1 2.97 1.25 3.176.155.205 2.164 3.303 5.242 4.63.732.316 1.302.505 1.747.646.735.234 1.403.201 1.93.122.588-.088 1.834-.75 2.09-1.47.256-.72.256-1.338.179-1.47-.076-.13-.282-.205-.59-.36z"/></svg>
          Message us on WhatsApp
        </a>
        <button type="button" class="jlps-btn-secondary jlps-btn-reset">Scan another photo</button>
      `;
    } else {
      grid.style.display = 'grid';
      grid.innerHTML = matches.map(m => {
        const url = escapeHtml(m.url || '#');
        const imageUrl = escapeHtml(m.image_url || '');
        const title = getTruncatedEscapedTitle(m.title);
        const scorePercent = formatScore(m.score);
        const typeOfItem = escapeHtml(m.type_of_item || 'Light');
        const badgeHtml = getConfidenceBadge(m.confidence);

        return `
          <a href="${url}" class="jlps-match-card" target="_blank" rel="noopener">
            <div class="jlps-match-thumb-container">
              <img class="jlps-match-thumb" src="${imageUrl}" alt="${title}" loading="lazy">
            </div>
            <div class="jlps-match-info">
              <h4 class="jlps-match-title">${title}</h4>
              <p class="jlps-match-meta">${scorePercent}% match &middot; ${typeOfItem}</p>
              <div class="jlps-match-badge-row">
                ${badgeHtml}
              </div>
            </div>
          </a>
        `;
      }).join('');

      footerActions.innerHTML = `
        <a href="${waLink}" target="_blank" rel="noopener" class="jlps-wa-btn">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 4px;"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.717-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.632-1.023-5.105-2.887-6.97C16.587 1.968 14.117.943 11.487.942c-5.442 0-9.866 4.42-9.87 9.852 0 1.764.464 3.486 1.343 5.006l-1.016 3.71 3.818-1.002zM17.65 14.4c-.31-.155-1.833-.903-2.115-1.005-.281-.102-.486-.153-.69.155-.205.307-.792 1.005-.97 1.21-.179.205-.357.23-.667.076-.31-.155-1.308-.482-2.492-1.538-.92-.82-1.54-1.833-1.72-2.14-.18-.307-.02-.473.136-.628.14-.138.31-.357.466-.537.155-.179.207-.307.31-.512.102-.205.05-.383-.025-.537-.075-.154-.69-1.662-.945-2.277-.25-.598-.5-.517-.69-.527-.179-.008-.383-.01-.588-.01-.205 0-.537.076-.819.383-.282.307-1.074 1.05-1.074 2.56 0 1.51 1.1 2.97 1.25 3.176.155.205 2.164 3.303 5.242 4.63.732.316 1.302.505 1.747.646.735.234 1.403.201 1.93.122.588-.088 1.834-.75 2.09-1.47.256-.72.256-1.338.179-1.47-.076-.13-.282-.205-.59-.36z"/></svg>
          Message us on WhatsApp
        </a>
        <button type="button" class="jlps-btn-secondary jlps-btn-reset">Scan another photo</button>
      `;
    }

    const resetBtn = footerActions.querySelector('.jlps-btn-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', resetModalState);
    }

    showState('results');
  }

  function renderError() {
    const grid = card.querySelector('.jlps-results-grid');
    const msgArea = card.querySelector('.jlps-message-area');
    const footerActions = card.querySelector('.jlps-footer-actions');

    grid.innerHTML = '';
    grid.style.display = 'none';

    msgArea.innerHTML = `
      <p class="jlps-error-message">Unable to connect to search service. Please check your connection and try again, or chat with us directly.</p>
    `;

    const waLink = `https://wa.me/919899188821?text=${encodeURIComponent('help me find this light')}`;
    footerActions.innerHTML = `
      <a href="${waLink}" target="_blank" rel="noopener" class="jlps-wa-btn">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" style="margin-right: 4px;"><path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.717-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.86-4.42 9.864-9.852.002-2.632-1.023-5.105-2.887-6.97C16.587 1.968 14.117.943 11.487.942c-5.442 0-9.866 4.42-9.87 9.852 0 1.764.464 3.486 1.343 5.006l-1.016 3.71 3.818-1.002zM17.65 14.4c-.31-.155-1.833-.903-2.115-1.005-.281-.102-.486-.153-.69.155-.205.307-.792 1.005-.97 1.21-.179.205-.357.23-.667.076-.31-.155-1.308-.482-2.492-1.538-.92-.82-1.54-1.833-1.72-2.14-.18-.307-.02-.473.136-.628.14-.138.31-.357.466-.537.155-.179.207-.307.31-.512.102-.205.05-.383-.025-.537-.075-.154-.69-1.662-.945-2.277-.25-.598-.5-.517-.69-.527-.179-.008-.383-.01-.588-.01-.205 0-.537.076-.819.383-.282.307-1.074 1.05-1.074 2.56 0 1.51 1.1 2.97 1.25 3.176.155.205 2.164 3.303 5.242 4.63.732.316 1.302.505 1.747.646.735.234 1.403.201 1.93.122.588-.088 1.834-.75 2.09-1.47.256-.72.256-1.338.179-1.47-.076-.13-.282-.205-.59-.36z"/></svg>
      Message us on WhatsApp
    </a>
    <button type="button" class="jlps-btn-secondary jlps-btn-reset">Try again</button>
  `;

  const resetBtn = footerActions.querySelector('.jlps-btn-reset');
  if (resetBtn) {
    resetBtn.addEventListener('click', resetModalState);
  }

  showState('results');
}

  // Inject camera icon to matched search inputs
  function injectCameraButton() {
    const selectors = [
      'input[type="search"]',
      'input[name="q"]',
      '.search__input',
      'input[type="text"][name="q"]'
    ];
    const inputs = document.querySelectorAll(selectors.join(', '));

    inputs.forEach(input => {
      // Guard against double injection
      if (input.getAttribute('data-jlps-injected') === 'true') return;

      // Adjust parent container positioning if static
      if (input.parentElement) {
        const computedStyle = window.getComputedStyle(input.parentElement);
        if (computedStyle.position === 'static') {
          input.parentElement.style.position = 'relative';
        }
      }

      // Create camera button
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'jlps-camera-btn';
      button.setAttribute('aria-label', 'Search by photo');
      button.textContent = '📷';

      // Check if there is an existing submit/search button in the same parent container
      const searchBtn = input.parentElement.querySelector('.search__button, button[type="submit"], .field__button');
      if (searchBtn) {
        button.classList.add('jlps-camera-btn--with-button');
      }

      // Insert right after input inside parent
      input.parentNode.insertBefore(button, input.nextSibling);

      // Mark as injected only after the button was successfully inserted,
      // so a mid-loop failure can be retried on the next observer pass
      input.setAttribute('data-jlps-injected', 'true');

      // Event listener
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal();
      });
    });
  }

  // MutationObserver to capture dynamically added search boxes
  // JL-SPEED-PS-001: rescan at most once per 250ms instead of on every DOM change
  let jlpsQueued = false;
  const observer = new MutationObserver(() => {
    if (jlpsQueued) return;
    jlpsQueued = true;
    setTimeout(() => { jlpsQueued = false; injectCameraButton(); }, 250);
  });

  // Initialization sequence
  function init() {
    injectStyles();
    injectModal();
    injectCameraButton();

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
